import SearchIcon from '@mui/icons-material/Search'
import {
  IconButton,
  InputAdornment,
  SxProps,
  TextField,
  Theme,
} from '@mui/material'
import React, { ChangeEvent, KeyboardEvent, useState } from 'react'

interface SearchBarProps {
  placeholder?: string
  onSearch?: (searchTerm: string) => void
  onChange?: (searchTerm: string) => void
  buttonStyle?: SxProps<Theme>
  inputStyle?: SxProps<Theme>
  size?: 'small' | 'medium'
  disabled?: boolean
}

export const SearchBar: React.FC<SearchBarProps> = ({
  placeholder = 'Search...',
  onSearch = () => {},
  onChange = () => {},
  buttonStyle = {},
  inputStyle = {
    backgroundColor: 'white',
  },
  size = 'small',
  disabled = false,
}) => {
  const [searchTerm, setSearchTerm] = useState<string>('')

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value
    setSearchTerm(newValue)
    onChange(newValue)
  }

  const handleSearch = () => {
    onSearch(searchTerm)
  }

  const handleKeyPress = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter') {
      handleSearch()
    }
  }

  return (
    <TextField
      variant='outlined'
      placeholder={placeholder}
      value={searchTerm}
      onChange={handleChange}
      onKeyPress={handleKeyPress}
      InputProps={{
        endAdornment: (
          <InputAdornment position='end'>
            <IconButton edge='end' onClick={handleSearch} sx={buttonStyle}>
              <SearchIcon />
            </IconButton>
          </InputAdornment>
        ),
      }}
      sx={{ width: 200, ...inputStyle }}
      size={size}
      disabled={disabled}
    />
  )
}
